import treatmentPlanTypeBraces from '@constants/treatmentPlanTypeBraces'

export default [
  {
    value: treatmentPlanTypeBraces.NEW,
    label: 'New treatment',
  },
  {
    value: treatmentPlanTypeBraces.MID,
    label: 'Ongoing treatment',
  },
]
